export default __webpack_public_path__ + "static/media/Kakwet.9d7a6193.png";